module.exports = __webpack_public_path__ + "img/patient-bg.7634cabf.jpg";